import { ScheduleXCalendar } from '@schedule-x/react'
import '@schedule-x/theme-default/dist/index.css'
import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { LoadRooms } from './actions/load-rooms'
import { LoadSessionsDate } from './actions/load-sessions-date'
import { EventModal } from './components/event-modal'
import { FormRooms } from './components/form-rooms'
import { FormSession } from './components/form-session'
import { TimeGridEvent } from './components/time-grid-event'

export function RoomsAndSessions() {
  const [params] = useSearchParams()
  const { reloadSessions, calendarSessions } = LoadSessionsDate()
  const { data: romms, load: loadRooms } = LoadRooms()

  useEffect(() => {
    if (calendarSessions) {
      reloadSessions()
      loadRooms()
    }
  }, [params, calendarSessions])

  console.debug('calendars', { calendarSessions: calendarSessions?.events.getAll() })

  return (
    <div className="flex flex-col gap-4">
      <header className="flex gap-2 items-end w-full justify-between">
        <h3 className="font-bold text-xl">Calendário de aulas</h3>
        <div className="flex gap-2">
          <FormRooms updateRomms={loadRooms} />
          <FormSession updateSessions={reloadSessions} rooms={romms} />
        </div>
      </header>
      <ScheduleXCalendar
        calendarApp={calendarSessions}
        customComponents={{
          eventModal: EventModal,
          timeGridEvent: TimeGridEvent
        }}
      />
    </div>
  )
}
